export default __webpack_public_path__ + "static/media/Pedestal Icons_Quantum.c5db34a4.svg";